import * as authentications from './authentications';
import * as users from './users';
import * as rounds from './rounds';
import * as shots from './shots';
import * as clubs from './clubs';
import * as documentation from './documentation';
import * as admin from './admin';
import * as licenses from './licenses';
import * as stats from './stats';
import * as events from './events';
import * as queues from './queues';

export default {
  admin,
  authentications,
  users,
  rounds,
  shots,
  clubs,
  documentation,
  licenses,
  stats,
  events,
  queues,
};
